import { FloatButton, Layout, theme } from 'antd'
import React, { Suspense } from 'react'
import TopMenu from '../components/TopMenu'
import styles from '../less/BaseLayout.module.less'
import { appVersion } from '../lib/general'
import { ImpersonationBar } from '../ImpersonationBar'
import { AnnouncementAlert } from './AnnouncementAlert'
import { useBreakpointContext } from '../lib/useBreakpointContext'
import { BaseLayoutContext } from './BaseLayoutContext'
export default function BaseLayout({ children }) {
  const { token } = theme.useToken()
  const [topMenu, setTopMenu] = React.useState({})
  const breakpoint = useBreakpointContext()

  return (
    <BaseLayoutContext.Provider value={[topMenu, setTopMenu]}>
      <Layout>
        <Suspense fallback={null}>
          <ImpersonationBar />
          <AnnouncementAlert />
        </Suspense>
        <Layout.Header
          className={styles.header}
          style={{
            marginTop: breakpoint.lg ? token.marginLG : 0,
            marginBottom: breakpoint.lg ? token.marginLG : token.marginSM,
          }}
        >
          <TopMenu />
        </Layout.Header>
        <Layout.Content className={styles.content}>{children}</Layout.Content>
        <Layout.Footer
          style={{
            textAlign: 'center',
            fontSize: '0.8em',
            color: token.colorTextQuaternary,
          }}
        >
          {appVersion}
        </Layout.Footer>
        <FloatButton.BackTop style={{ bottom: 94, right: 24 }} />
      </Layout>
    </BaseLayoutContext.Provider>
  )
}
